var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4266 17.3362C20.8258 17.8168 19.9247 17.7568 19.4141 17.126C18.9034 16.4952 19.0236 15.5941 19.6544 15.0835C20.4654 14.4226 20.976 13.4014 20.976 12.29C20.976 11.0885 20.4053 10.0372 19.5042 9.37638C18.9335 8.95586 18.8434 8.11482 19.2939 7.57415L19.4141 7.454C19.8947 6.88329 20.7958 6.76314 21.3665 7.2137C22.8683 8.38515 23.8295 10.2475 23.8295 12.29C23.8295 14.3325 22.8984 16.1348 21.4266 17.3362Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7006 21.3611C24.0998 21.8417 23.2287 21.7216 22.7181 21.1509C22.2375 20.5501 22.2976 19.649 22.8983 19.1684C24.8808 17.5164 26.1724 15.0533 26.1724 12.2899C26.1724 9.52647 24.8808 7.03338 22.8983 5.41137C22.2976 4.93077 22.2375 4.02966 22.7181 3.42891C23.1987 2.82817 24.0998 2.70802 24.7006 3.18862C27.3438 5.32126 29.056 8.59532 29.056 12.2599C29.0259 15.9544 27.3438 19.2285 24.7006 21.3611Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.046 23.5539L5.74699 17.937H2.17256C1.24141 17.937 0.490479 17.1861 0.490479 16.2549V8.32507C0.490479 7.39392 1.24141 6.64299 2.17256 6.64299H5.74699L13.0761 1.02603C14.3677 0.0347977 16.1999 0.935913 16.1999 2.58796V22.0221C16.1999 23.614 14.3376 24.5452 13.046 23.5539Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.6cecb9ed878c57f3b3ff96919f810b09.svg";
export { ForwardRef as ReactComponent };